<button type="button"
        [matMenuTriggerFor]="modelMenu"
        matButton
        #tooltip="matTooltip"
        [matTooltip]="getModelTooltip()"
        matTooltipPosition="above"
        aria-label="Select model"
        [disabled]="isInputDisabled()">
  {{ selectedModel.model }}
  <mat-icon iconPositionEnd fontIcon="expand_more"/>
</button>

<mat-menu #modelMenu="matMenu" class="model-menu">
  <div class="model-search-container" (click)="$event.stopPropagation()">
    <mat-form-field appearance="outline" class="model-search">
      <mat-label>Search Models</mat-label>
      <input matInput (keyup)="filterModels($event)" placeholder="Search Models" autocomplete="off">
      <mat-icon matSuffix fontIcon="search"></mat-icon>
    </mat-form-field>
  </div>
  <div class="model-list">
    @if (groupedModels().length === 0) {
      <div class="empty-models">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Loading available models...</span>
      </div>
    } @else {
      @for (accountGroup of groupedModels(); track accountGroup.accountName) {
        <div class="account-group">
          <div class="account-name">{{ accountGroup.accountName }}</div>
          @for (model of accountGroup.models; track model.name) {
            <button mat-menu-item class="btn-item" (click)="selectModel(accountGroup.accountName, model.name)">
              @defer {
                @if (isSelectedModel(accountGroup.accountName, model.name)) {
                  <ng-container>
                    <div class="model-selected">
                      <span class="model-label-selected">
                        <span class="model-name">{{ model.name }}</span>
                        <mat-icon class="icon-sm" fontIcon="check"></mat-icon>
                      </span>
                    </div>
                        @if (model.description) {
                          <div class="model-description">{{ model.description }}</div>
                        }
                  </ng-container>
                } @else {
                  <span class="model-label">
                    <span class="model-name">{{ model.name }}</span>
                    @if (model.description) {
                      <div class="model-description">{{ model.description }}</div>
                    }
                  </span>
                }
              }
            </button>
          }
        </div>
      }
    }
  </div>
</mat-menu>
